import {
  CHECK_DATA_TO_DLT_COMPANY_LIST,
  CHECK_DATA_TO_DLT_LOG,
  CHECK_DATA_TO_DLT_CHECK_DLT,
  UPDATE_CHECK_LIST,
  CHECK_DATA_TO_DLT_MULTI_CHECK_DLT,
} from "./actions";

const initialState = {
  // *ดึงข้อมูล company list
  check_company_list: false,
  company_list: [],

  // *ดึงข้อมูล log
  check_log: false,
  log_list: [],

  // *check dlt
  check_dlt: false,
  dlt_list: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_DATA_TO_DLT_COMPANY_LIST.REQUEST:
      return {
        ...state,
        check_company_list: true,
        company_list: [],
      };
    case CHECK_DATA_TO_DLT_COMPANY_LIST.SUCCESS:
      return {
        ...state,
        company_list: action.payload.lists || [],
        check_company_list: false,
      };

    case CHECK_DATA_TO_DLT_LOG.REQUEST:
      return {
        ...state,
        check_log: true,
        log_list: [],
      };
    case CHECK_DATA_TO_DLT_LOG.SUCCESS:
      return {
        ...state,
        log_list: action.payload.lists || [],
        check_log: false,
      };

    case CHECK_DATA_TO_DLT_CHECK_DLT.REQUEST:
      return {
        ...state,
        check_dlt: true,
        dlt_list: [],
      };
    case CHECK_DATA_TO_DLT_CHECK_DLT.SUCCESS:
      return {
        ...state,
        dlt_list: action.payload.lists || [],
        check_dlt: false,
      };
    case CHECK_DATA_TO_DLT_MULTI_CHECK_DLT.REQUEST:
      return {
        ...state,
        check_dlt: true,
        dlt_list: [],
      };
    case CHECK_DATA_TO_DLT_MULTI_CHECK_DLT.SUCCESS:
      return {
        ...state,
        dlt_list: action.payload.lists || [],
        check_dlt: false,
      };

    case UPDATE_CHECK_LIST.REQUEST:
      return {
        ...state,
        check_log: true,
      };
    case UPDATE_CHECK_LIST.SUCCESS:
      return {
        ...state,
        msg: "Update Success",
        status: "success",
        // check_log: false,
      };
    case UPDATE_CHECK_LIST.FAILURE:
      return {
        ...state,
        msg: action.payload.err,
        check_log: false,
        status: "fail",
        shouldReload: false,
      };

    default:
      return state;
  }
};
